import { Widget } from "fmko-ts-common";
import { CertTestCaseVO, CertTestVO } from "./RestTypes";
import CertTestService from "./CertTestService";
import CertTestAdminApp from "./CertTestAdminApp";

export default class SubjectTestCaseWidget extends Widget {
    testCase: CertTestCaseVO;
    test: CertTestVO;
    input: Array<HTMLInputElement>;

    constructor(test: CertTestVO, testCase: CertTestCaseVO) {
        super();

        this.testCase = testCase;
        this.test = test;

        this.input = new Array<HTMLInputElement>();

        let div = document.createElement("div");

        for (let i = 0; i < testCase.params.length; i++) {
            this.input[i] = document.createElement("input");
            this.input[i].value = testCase.params[i].value;
            this.input[i].name = testCase.params[i].name;
            this.input[i].title = testCase.params[i].description;
            this.input[i].setAttribute("regex", testCase.params[i].regex);
            this.input[i].setAttribute("validationMessage", testCase.params[i].validationMessage);

            this.input[i].addEventListener("keyup", (ev: KeyboardEvent) => {
                if (ev.key === "Enter") {
                    // Return key
                    this.saveIfValidInput((ev.target as HTMLInputElement).getAttribute("name"));
                }

            });

            let button = document.createElement("button");
            button.innerHTML = '<span class="glyphicon glyphicon-save"></span>';
            button.className = "btn btn-primary";
            button.name = testCase.params[i].name;

            button.addEventListener("click", (ev) => {
                let name = (<HTMLInputElement>ev.target).getAttribute("name");
                if (!name) {
                    name = (<HTMLInputElement>ev.target).parentElement.getAttribute("name");
                }
                this.saveIfValidInput(name);
            });

            let innerDiv = document.createElement("div");
            innerDiv.appendChild(document.createTextNode(testCase.params[i].name));
            innerDiv.appendChild(this.input[i]);
            innerDiv.appendChild(document.createTextNode(" "));
            innerDiv.appendChild(button);
            innerDiv.appendChild(document.createTextNode(" "));
            div.appendChild(innerDiv);
        }

        this.element = div;
    }

    private saveIfValidInput(s: string) {
        let prop = this.input.filter(p => p.name === s)[0];
        let regexp = new RegExp(prop.getAttribute("regex"));
        if (regexp.test(prop.value)) {
            try {

                CertTestService.getInstance().updateTestCaseParam(this.test.name, this.testCase.testID, prop.name,
                    prop.value).then((testCase) => {
                    CertTestAdminApp.certTestPanel.reload().then(() => {
                        CertTestAdminApp.certTestPanel.focusTestCase(this.testCase.testID);
                    });
                }).catch(err => CertTestAdminApp.alert("Opdatér fejlede", err.message));
                return;
            } catch (e) {
                console.log("get an exception: " + e);
            }
        }
        window.alert(prop.getAttribute("validationMessage"));

    }
}
